// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5546":"539ad024","9154":"1b652738","9303":"7db75299","9322":"4633a33f"}[chunkId] + ".chunk.css";
};